
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mesonet-climate/stats",
      function () {
        return require("private-next-pages/mesonet-climate/stats.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mesonet-climate/stats"])
      });
    }
  